import { useEffect, useRef, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { Formik } from "formik";
import _ from 'lodash';
import { HeaderRegister } from "../../../components/HeaderRegister";
import { ToastService } from "../../../services/toast.service";
import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault } from '../../../models/requestInputOutputParams.model';
import BranchService from "../../../services/branch.service";

export interface configImpositionModelCit {
  id: number;
  fullName: string;
  checked: boolean;
  isBranchWithoutPickupIntegration: boolean;
}

export const CITConfig = () => {

  const [initialValues, setInitialValues] = useState({
    selectionTypeId: "3", // Definindo o valor padrão como "3"
    listValues: []
  });

  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const formRef = useRef();
  const [selectedList, setSelectedList] = useState([]);

  const initialize = async () => {
    setLoading(true);

    // Carregar os dados do tipo de configuração correspondente ao id "3"
    BranchService.getAll().then((response: any) => {
      const listValuesWithCheck = response.result.datasets[0].data.map((item: configImpositionModelCit) => {
        return {
          ...item,
          checked: item.isBranchWithoutPickupIntegration // Definir o estado inicial do checkbox com base em isBranchWithoutPickupIntegration
        };
      });
      //console.log("list Value", listValuesWithCheck)
      setInitialValues(prevValues => ({
        ...prevValues,
        listValues: listValuesWithCheck
      }));

      // Initialize selectedList with all IDs
      const selectedIds = listValuesWithCheck
        .filter(item => item.isBranchWithoutPickupIntegration)
        .map(item => item.id);

      setSelectedList(selectedIds);
      setLoading(false);
    }).catch(error => {
      setLoading(false);
      console.error("Error loading data:", error);
    });
  };

  useEffect(() => {
    initialize();
  }, []);

  const returnSubTitle = (label: string) => {
    if (label == '1')
      return t('CONFIG.GROUP_GENERAL');
    if (label == '2')
      return t('CONFIG.GROUP_PROFILE');
    if (label == '3')
      return t('CONFIG.PARAMETER_CIT_SUBTTITLE');
    if (label == '4')
      return t('CONFIG.GROUP_BRANCH_ACTION');
    if( label == '5')
      return t('CONFIG.GROUP_BRANCH_ACTION_CASH_CHANGE_DELIVERY')

    return '';
  }

  const selectAll = (checked: boolean, list: configImpositionModelCit[]) => {
    const updatedList = list.map((item) => {
      return { ...item, checked: checked };
    });
    const selected = checked ? updatedList.map(item => item.id) : [];
    setInitialValues(prevValues => ({
      ...prevValues,
      listValues: updatedList
    }));
    setSelectedList(selected);
  };

  const allSelected = (list: configImpositionModelCit[]) => {
    return list.length > 0 && list.every(item => item.checked);
  };

  const toggleCheckbox = (id: number) => {
    const updatedList = initialValues.listValues.map((item) => {
      if (item.id === id) {
        return { ...item, checked: !item.checked };
      }
      return item;
    });
    const selected = updatedList.filter(item => item.checked).map(item => item.id);
    setInitialValues(prevValues => ({
      ...prevValues,
      listValues: updatedList
    }));
    setSelectedList(selected);
  };

  const submitFormik = () => {
    if (formRef && formRef.current) {
      let current: any = formRef.current;
      current.handleSubmit();
    }
  };

  const onSubmit = async (data) => {
    try {
      if (data.selectionTypeId == undefined || data.selectionTypeId == '') {
        ToastService.warn(t('CONFIG.ALERT_TYPE_NEEDED'), null);
        return;
      }

      const selectedValues = initialValues.listValues.map(item => ({
        branch_id: item.id,
        isBranchWithoutPickupIntegration: item.checked
      }));

      let dataset = {
        dataset: 'branch',
        data: selectedValues,

      };

      let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [dataset] };

      data.Id = data.selectionTypeId;
      data = selectedValues;
      // Sprint 30 - Para salvar as informações no BranchService
      const response: any = await BranchService.InsertBranchWithoutPickupIntegration(requestParams);
      //console.log("REsquest PAramns", requestParams)
      if (response.success) {
        ToastService.success(t('CONFIG.DATA_UPDATED'));
      } 
    } catch (error) {
      ToastService.error(t('ERROR_GENERIC'));
    }
  };

  return (
    <>
      <HeaderRegister
        title={`${t('CONFIG.PARAMETER_CIT_TITLE')}`}
        path={"/Models"}
        submitForm={submitFormik}
        isLoading={isLoading}
        btnBack={false}
      />

      <Formik
        enableReinitialize={true}
        innerRef={formRef}
        initialValues={initialValues}
        onSubmit={(values) => {
          onSubmit(values);
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          errors,
          setValues
        }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Row>
              <div>
                <h5>{t(returnSubTitle(values.selectionTypeId))}</h5>
                {values.selectionTypeId !== '1' && (
                  <Form.Check
                    type="checkbox"
                    label={t('SELECT_ALL')}
                    onChange={(event) => {
                      selectAll(event.target.checked, values.listValues);
                    }}
                    checked={allSelected(values.listValues)}
                  />
                )}
                <br />
              </div>
              <Form.Group>
                <Form.Floating>
                  <div style={{width: '80%', display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', boxSizing: 'border-box', flexDirection: 'row'}}>
                    {values.listValues.map((l: configImpositionModelCit) => (
                      <div key={l.id} style={{width: '33%', boxSizing: 'border-box'}}>
                        <Form.Check
                          type="checkbox"
                          id={l.id.toString()}
                          label={values.selectionTypeId === '2' ? t(`PROFILE.${l.fullName.toUpperCase()}`) : values.selectionTypeId === '1' ? t(l.fullName) : l.fullName}
                          checked={l.checked} // Marca o checkbox se checked for true
                          onChange={() => toggleCheckbox(l.id)}
                        />
                      </div>
                    ))}
                  </div>
                </Form.Floating>
              </Form.Group>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default CITConfig;
